import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { MouseEvent, useRef, useState } from "react";
import { IDropdownAction } from "ui/Scripts/source/components/framework/Dropdown/Dropdown";
import { AppAddIcon } from "../../Icon/AppAddIcon";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

interface IAddButtonAction extends IDropdownAction {
    fileInputAccept?: string;
    fileInputName?: string;
    onAddFilesClick?: (fileList: FileList) => void;
}

interface IAddButtonMenuItemProps {
    action: IAddButtonAction;
    disabled?: boolean;
    index: number;
    onClose: () => void;
}

const AddButtonMenuItem = (props: IAddButtonMenuItemProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleActionClick = (event: any, action: IAddButtonAction) => {
        if (!action) return;
        if (props.disabled || action.disabled) return;
        event.stopPropagation();
        action.onClick();
        props.onClose();
    };

    const handleFileActionChange = (e: React.ChangeEvent<HTMLInputElement>, action: IAddButtonAction) => {
        if (props.disabled || action.disabled) return;
        if (!e.target.files || e.target.files.length < 1) return;
        action.onAddFilesClick(e.target.files);
        props.onClose();
    };

    const action = props.action;

    return (
        <MenuItem key={action.title as string} onClick={action.onAddFilesClick ? () => inputRef.current.click() : (event) => handleActionClick(event, action)}>
            {action.icon && <ListItemIcon>{action.icon}</ListItemIcon>}
            <ListItemText>{action.title}</ListItemText>
            {!!action.onAddFilesClick &&
                <input ref={inputRef} type="file" name={action.fileInputName ?? ("File" + props.index.toString(10))} style={{ display: "none" }} multiple={true} accept={action.fileInputAccept} onChange={(e) => handleFileActionChange(e, action)} />
            }
        </MenuItem>
    );
};

interface IAddButtonProps extends IAppButtonProps {
    actions?: IAddButtonAction[];
}

export const AddButton = (props: IAddButtonProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleToggleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <AppButton variant="contained" startIcon={<AppAddIcon />} {...props} onClick={props.actions ? handleToggleClick : props.onClick}>
                {props.children}
            </AppButton>
            {props.actions &&
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                    {props.actions.map((action, index) => (
                        <AddButtonMenuItem
                            key={action.title as string}
                            action={action}
                            index={index}
                            onClose={handleClose}
                        />
                    ))}
                </Menu>
            }
        </>
    );
};
